import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ShangriLa = () => {
     const whatWeOfferRef = useRef(null); 
              
                const scrollToSection = () => {
                  if (whatWeOfferRef.current) {
                    whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
                  }
                };
  const features = [
    {
      title: "Light Control",
      description:
        "Easily adjust light levels with ShangriLa slats for perfect ambiance and privacy.",
    },
    {
      title: "Timeless Design",
      description:
        "Elegant ShangriLa blinds bring a natural warmth to your home, complementing any decor style.",
    },
    {
      title: "Durability",
      description:
        "Made from high-quality materials, ensuring long-lasting beauty and performance.",
    },
    {
      title: "UV Protection",
      description:
        "Block harmful UV rays while still allowing natural light into your space.",
    },
    {
      title: "Energy Efficiency",
      description:
        "ShangriLa blinds help improve insulation and reduce energy costs, keeping your home comfortable.",
    },
    {
      title: "Custom Fit",
      description:
        "Tailored to your window dimensions, ensuring a perfect fit for any room.",
    },
  ];
  
  const [activeIndex, setActiveIndex] = useState(null);
  
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  
  return (
    <div className='font-playfair'>
      
<section 
   className="object-cover h-screen bg-cover bg-center flex flex-col  items-center  pt-40 md:pt-32 "
   style={{ backgroundImage: "url('images/shang3.jpg')" }}
 >
  <div className=" text-center lg:px-24">
    <h1 className="text-6xl md:text-8xl 2xl:text-[130px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4  lg:text-8xl ">
    Shangri-La
    </h1>
    <h1 className="text-6xl md:text-8xl 2xl:text-[130px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4  lg:text-8xl ">
      Blinds
    </h1>
  </div>

  {/* Button positioned below the text */}
  <div className="mt-4 2xl:mt-6 flex justify-center  ">
    <button onClick={scrollToSection} className="text-black bg-[#fff] 2xltext-xl w-40 2xl:w-48 px-6 py-2">
      LEARN MORE
    </button>
  </div>
</section>
      <div className="flex flex-col xl:gap-20  xl:px-20">
        {/* Header Section */}
        <header className="text-center pt-20">
          <h1 ref={whatWeOfferRef} className="text-4xl md:text-5xl lg:text-8xl font-extrabold text-gray-900 mb-8 ">ShangriLa Blinds</h1>
        </header>

        {/* About ShangriLa Blinds */}
        <section className="mb-16 px-3 flex  flex-col lg:flex-row gap-6 xl:gap-20 justify-between items-center">
          <h2 className="text-2xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800  text-center">What are ShangriLa Blinds?</h2>
          <p className=" text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
          ShangriLa blinds are timeless and elegant window treatments that offer both aesthetic appeal and functionality. Made from durable materials, they enhance privacy, control light, and contribute to a cozy, natural atmosphere in any room.

          </p>
        </section>

        {/* Benefits of ShangriLa Blinds */}
        <section className="mb-16 px-3 flex flex-col lg:flex-row gap-10 md:gap-20 justify-between items-center">
          {/* < className=" text-xl text-gray-700"> */}
            <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
            ShangriLa blinds provide a sophisticated and practical solution for controlling light, privacy, and energy efficiency. The natural texture of the materials adds warmth and elegance to any space, while offering versatility and easy maintenance.
            </p>

          <h2 className="text-4xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 text-center">Benefits of ShangriLa Blinds</h2>

        </section>

        {/* How ShangriLa Blinds Work */}
        <section className="xl:mb-16 px-3 flex flex-col lg:flex-row gap-5 xl:gap-20 justify-between items-center">
          <h2 className="text-3xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 mb-4 text-center">How Do ShangriLa Blinds Work?</h2>
          <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify ">
          ShangriLa blinds operate by tilting the slats to adjust the amount of light that enters the room.
           Whether you need complete darkness or just a gentle flow of natural light, these blinds offer 
           an effortless way to create the ideal ambiance.
          </p>
        </section>
        </div>

      
 {/* Content Section */}
 <section className="py-16 px-2 md:px-6">
  <h2 className="text-3xl md:text-5xl lg:text-7xl font-bold text-center mb-10 md:mb-20 ">
    Transform Your Space with <br/>Motorized Blinds
  </h2>
  <div className="flex flex-col gap-20 xl:gap-40">
    {/* Benefit 1 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-arround">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8">Effortless Morning Comfort</h3>
        <p className="text-gray-600 text-xl  md:text-2xl xl:text-4xl text-justify">
        Start your day with the natural beauty of ShangriLa blinds, which gradually let in the light, creating a gentle sunrise effect. Perfect for waking up refreshed and energized, with a comfortable and soothing atmosphere.
        </p>
      </div>
      <div className="w-full ">
        <img
        className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/shang1.jpg"
          alt="Effortless Morning Comfort"
        />
      </div>
    </div>

    {/* Benefit 2 */}
    <div className="flex flex-col lg:flex-row-reverse gap-20 md:gap-5 items-center justify-between">
      <div className="w-full  max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Customized Comfort Throughout the Day</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        ShangriLa blinds give you control over your space, whether you need sunlight during the day or a cozy, dimmed atmosphere. Adjust them easily to suit your needs, whether it's for work or relaxation.

        </p>
      </div>
      <div className="w-full ">
        <img
         className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/shang2.jpg"
          alt="Customized Comfort Throughout the Day"
        />
      </div>
    </div>

    {/* Benefit 3 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-between">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Evening Elegance</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        Set the mood for your evening with ShangriLa blinds. Adjust them to achieve the perfect level of privacy and light, creating a relaxed and elegant atmosphere for any gathering or quiet night in.
        </p>
      </div>
      <div className="w-full ">
        <img
        className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/shang.jpg"
          alt="Evening Elegance"
        />
      </div>
    </div>
  </div>
</section>
       

    

      {/* Features */}
      <section className="mb-16 bg-white p-8 max-w-6xl mx-auto xl:pt-20">
        <h2 className="text-3xl md:text-6xl text-center font-semibold text-gray-800 mb-20">
          Key Features of ShangriLa Blinds
        </h2>
        <div>
          {features.map((feature, index) => (
            <div
              key={index}
              className="border-b border-gray-400 p-3 mb-4 "
            >
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-xl md:text-4xl font-semibold text-gray-800 mb-6">
                  {feature.title}
                </h3>
                <button
                  className="text-xl md:text-4xl font-bold text-gray-600"
                  aria-label="Toggle FAQ"
                >
                  {activeIndex === index ? "-" : "+"}
                </button>
              </div>
              {activeIndex === index && (
                <p className="text-gray-600 mt-2 text-base md:text-4xl">{feature.description}</p>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ShangriLa;

// import React, { useEffect, useRef } from 'react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

// gsap.registerPlugin(ScrollTrigger);

// const ShangriLa = () => {
//   const sectionRef = useRef(null);

//   useEffect(() => {
//     const ctx = gsap.context(() => {
//       gsap.from('.shangri-la-content', {
//         scrollTrigger: {
//           trigger: '.shangri-la-content',
//           start: 'top center+=100',
//           toggleActions: 'play none none reverse'
//         },
//         y: 30,
//         opacity: 0,
//         duration: 1,
//         stagger: 0.2
//       });

//       gsap.from('.collection-item', {
//         scrollTrigger: {
//           trigger: '.collections-grid',
//           start: 'top center+=100',
//           toggleActions: 'play none none reverse'
//         },
//         scale: 0.9,
//         opacity: 0,
//         duration: 0.8,
//         stagger: 0.2
//       });
//     }, sectionRef);

//     return () => ctx.revert();
//   }, []);

//   const collections = [
//     { name: 'Signature Series', image: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80' },
//     { name: 'Designer Collection', image: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80' },
//     { name: 'Luxury Line', image: 'https://images.unsplash.com/photo-1513519245088-0e12902e35a0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80' }
//   ];

//   return (
//     <section ref={sectionRef} className="py-20 bg-gradient-to-r from-rose-50 to-teal-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-16">
//           <h2 className="text-4xl font-bold text-gray-900 mb-4">Shangri-La Blinds</h2>
//           <p className="text-xl text-gray-600 max-w-2xl mx-auto">
//             Where luxury meets functionality in perfect harmony
//           </p>
//         </div>

//         <div className="shangri-la-content grid lg:grid-cols-2 gap-12 items-center mb-20">
//           <div className="relative">
//             <div className="absolute -top-4 -left-4 w-72 h-72 bg-rose-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
//             <div className="absolute -bottom-4 -right-4 w-72 h-72 bg-teal-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
//             <div className="relative aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl">
//               <img
//                 src="https://images.unsplash.com/photo-1513694203232-719a280e022f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
//                 alt="Shangri-La Showcase"
//                 className="w-full h-full object-cover"
//               />
//             </div>
//           </div>

//           <div className="space-y-8">
//             <div className="bg-white/80 backdrop-blur-lg p-8 rounded-xl shadow-lg">
//               <h3 className="text-2xl font-bold mb-4">Ethereal Elegance</h3>
//               <p className="text-gray-600 mb-6">
//                 Experience the perfect balance of light and privacy with our innovative fabric vane design
//               </p>
//               <div className="grid grid-cols-2 gap-4">
//                 <img
//                   src="https://images.unsplash.com/photo-1513519245088-0e12902e35a0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                   alt="Detail 1"
//                   className="w-full aspect-square object-cover rounded-lg"
//                 />
//                 <img
//                   src="https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                   alt="Detail 2"
//                   className="w-full aspect-square object-cover rounded-lg"
//                 />
//               </div>
//             </div>

//             <div className="grid grid-cols-2 gap-6">
//               <div className="bg-white/80 backdrop-blur-lg p-6 rounded-xl shadow-lg">
//                 <img
//                   src="https://images.unsplash.com/photo-1513694203232-719a280e022f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                   alt="Feature 1"
//                   className="w-full aspect-video object-cover rounded-lg mb-4"
//                 />
//                 <h4 className="text-lg font-semibold">Superior Privacy</h4>
//               </div>
//               <div className="bg-white/80 backdrop-blur-lg p-6 rounded-xl shadow-lg">
//                 <img
//                   src="https://images.unsplash.com/photo-1513519245088-0e12902e35a0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                   alt="Feature 2"
//                   className="w-full aspect-video object-cover rounded-lg mb-4"
//                 />
//                 <h4 className="text-lg font-semibold">Light Control</h4>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="collections-grid mb-20">
//           <h3 className="text-3xl font-bold text-center mb-12">Premium Collections Continuing with the ShangriLa.tsx component:

// ```jsx
//           </h3>
//           <div className="grid md:grid-cols-3 gap-8">
//             {collections.map((collection, index) => (
//               <div key={index} className="collection-item group">
//                 <div className="relative aspect-[3/4] rounded-xl overflow-hidden shadow-lg mb-4">
//                   <img
//                     src={collection.image}
//                     alt={collection.name}
//                     className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
//                   />
//                   <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
//                     <div className="text-white">
//                       <h4 className="text-xl font-semibold">{collection.name}</h4>
//                       <p className="text-sm opacity-90">Explore Collection</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="grid grid-cols-6 gap-4">
//           {[1, 2, 3, 4, 5, 6].map((item) => (
//             <div key={item} className="collection-item relative aspect-square rounded-lg overflow-hidden shadow-lg">
//               <img
//                 src={`https://images.unsplash.com/photo-${item % 2 === 0 ? '1513519245088-0e12902e35a0' : '1484154218962-a197022b5858'}?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80`}
//                 alt={`Gallery ${item}`}
//                 className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
//               />
//               <div className="absolute inset-0 bg-black/40 opacity-0 hover:opacity-100 transition-opacity duration-300" />
//             </div>
//           ))}
//         </div>

//         <div className="mt-20 bg-white/90 backdrop-blur-lg p-8 rounded-xl shadow-lg">
//           <h3 className="text-2xl font-bold mb-6">Available Colors</h3>
//           <div className="grid grid-cols-3 md:grid-cols-6 gap-6">
//             {['Pearl White', 'Champagne', 'Platinum Gray', 'Soft Beige', 'Misty Rose', 'Ocean Mist'].map((color) => (
//               <div key={color} className="text-center group">
//                 <div className="relative">
//                   <div className="w-20 h-20 rounded-full bg-gradient-to-br from-white to-gray-200 border-2 border-gray-100 mx-auto mb-2 transition-transform duration-300 group-hover:scale-110"></div>
//                   <img
//                     src={`https://images.unsplash.com/photo-1513519245088-0e12902e35a0?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80`}
//                     alt={color}
//                     className="absolute inset-0 w-full h-full object-cover rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
//                   />
//                 </div>
//                 <span className="text-sm text-gray-600">{color}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ShangriLa;